import { Box, Typography } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	FieldLayout,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../common/constants";

import { CountryService } from "../../../services/common/CountryService";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { IAppState } from "../../../store/reducers";
import { LookupFieldService } from "../../../services/LookupFieldService";
import { ProvinceService } from "../../../services/common/ProvinceService";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";
import { useNavigateToLogout } from "../../../common/Common";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

interface IEmployeePayrollSetupFieldsPanel extends ITest {
	isAdminUser: any;
	countryList: any;
	vacationPayFromGetById: any;
	loadedEmployeeId: any;
	payFrequencyDDLItems: any;
	onPayFrequencyChangeHandler: (value: any) => void
	employeePermissionsData: any
	companyInformation: any
	general_settings: any
	id: any
}
export const useGetLookupFieldData = (lookupFieldId: string) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
		queryFn: (data) => {
			return LookupFieldService.getByIdd(lookupFieldId);
		},
		refetchOnWindowFocus: false,
	});
export const EmployeePayrollSetupFieldsPanel: FC<
	IEmployeePayrollSetupFieldsPanel
> = ({ isAdminUser, countryList, vacationPayFromGetById, loadedEmployeeId, payFrequencyDDLItems, onPayFrequencyChangeHandler, employeePermissionsData, companyInformation, general_settings , id}) => {
	// const { isLoading: isLoadingPayPeriods, data: payPeriodsList } =
	// 	useGetLookupFieldData("payPeriods");
	const navigateToLogout = useNavigateToLogout();
	const canada = useSelector((state: IAppState) => state.countryAndProvincesInfo.canada);
	const canadaProvinces = useSelector((state: IAppState) => state.countryAndProvincesInfo.canadaProvinces);

	const [provinceOrStateDDL, setprovinceOrStateDDL] = useState<any>(undefined);
	const [payOutVacationPayDisabled, setPayOutVacationPayDisabled] =
		useState(false);

	useEffect(() => {
		// if (countryList) {

		// 	setprovinceOrStateDDL(provinceDDLItems);
		// }
		// if (countryList && Array.isArray(countryList) && !loadedEmployeeId) {
		// 	const canada = countryList.find(
		// 		(item: any) => item.label === "Canada" || "canada"
		// 	);
		// 	if (canada) {
		// 		// setSelectedCountry(canada.value);
		// 		(async () => {
		// 			try {
		// 				// provinceDDLLoading(true);
		// 				const response = await CountryService.getProvinceOrStateDDL(
		// 					navigateToLogout,
		// 					canada.value,
		// 					"Province"
		// 				);
		// 				setprovinceOrStateDDL(response);
		// 				// provinceDDLItems(response);
		// 			} catch (err) {
		// 				console.error("error", err);
		// 			}
		// 		})();
		// 	} else {
		// 		setprovinceOrStateDDL(undefined);
		// 	}
		// }
		if (canada && canada?.shortCode === 'CAN' && canadaProvinces) {
			setprovinceOrStateDDL(canadaProvinces);
		}
		if (vacationPayFromGetById) {
			if (
				vacationPayFromGetById.vacationPay &&
				vacationPayFromGetById.vacationPay === 200
			) {
				setPayOutVacationPayDisabled(true);
			} else {
				setPayOutVacationPayDisabled(false);
			}
		}
		if (general_settings) {
			if (
				general_settings.vacationPayOnPaidVacPay &&
				general_settings.vacationPayOnPaidVacPay === 200
			) {
				setPayOutVacationPayDisabled(true);
			}
			//  else {
			// 	setPayOutVacationPayDisabled(false);
			// }
		}
	}, [vacationPayFromGetById, loadedEmployeeId, canadaProvinces, canada, general_settings]);

	const onVacationPaySelectionChangeHandler = (item: any) => {
		if (item.value === 200) {
			setPayOutVacationPayDisabled(true);
		} else {
			setPayOutVacationPayDisabled(false);
		}
	};

	// fixed Province DDL for Country CANADA
	// const useGetProvinceDDL = () => {
	// 	return useQuery({
	// 		queryKey: [GET_QUERY_KEY.PROVINCE_DDL],
	// 		queryFn: () => ProvinceService.get(),
	// 		...QUERY_OPTIONS,
	// 	});
	// };
	// const { data: provinceList } = useGetProvinceDDL();
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				selectName="payFrequency"
				label="Payroll Schedule"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Pay-Frequency-list`}
				items={payFrequencyDDLItems ?? []}
				// selectedItem={26}
				labelColumns={4}
				fieldColumns={8}
				onSelectionChangeHandler={onPayFrequencyChangeHandler}
				isDisabled={id && employeePermissionsData && employeePermissionsData.salaryProfileExist}
			/>
			<RHookFormDatePicker
				name="dateOfHire"
				testId="Date-of-hire"
				label="Date of hire"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
				disabled={id && employeePermissionsData && employeePermissionsData.salaryProfileExist}
			/>
			{companyInformation && companyInformation.paymentSetup === 100 ?
				<Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px", display: "flex", justifyContent: "space-between" }}>
					<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
						Pay Method
					</Typography>
					<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
						Cheque
					</Typography>
				</Box> :
				<EnhancedDropDownRHFWithLabel
					selectName="payMethod"
					label="Pay Method"
					labelPosition={LabelPosition.Top}
					// required
					testId={`Pay-Method-list`}
					items={[
						// { label: "Cash", value: 100 },
						{ label: "Cheque", value: 200 },
						{ label: "Direct Deposit", value: 300 },
					]}
					selectedItem={100}
					labelColumns={4}
					fieldColumns={8}
				/>}
			{/* {provinceOrStateDDL && ( */}
			<EnhancedDropDownRHFWithLabel
				selectName="provinceOfEmployment"
				label="Province of Employment"
				// selectedItem={selectedProvince.shortCode}
				labelPosition={LabelPosition.Top}
				// required
				testId={`province-of-employement`}
				items={provinceOrStateDDL ?? []}
			// items={provinceList ?? []}
			// onSelectionChangeHandler={handleSelectChange}
			/>
			{/* )} */}
			{/* <RHookFormDatePicker
				name="dateOfTermination"
				testId="Date-of-Termination"
				label="Date of Termination"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/> */}
			<EnhancedDropDownRHFWithLabel
				selectName="vacationPay"
				label="Vacation Pay"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Vacation-Pay`}
				items={[
					{ label: "Calculate", value: 100 },
					{ label: "Disable", value: 200 },
				]}
				selectedItem={100}
				onSelectionChangeHandler={onVacationPaySelectionChangeHandler}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="payOutVacationPay"
				label="Pay out Vacation Pay "
				labelPosition={LabelPosition.Top}
				// required
				testId={`Pay-out-Vacation-Pay`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
				isDisabled={payOutVacationPayDisabled}
			/>
			<FieldWrapper>
				<FieldLayout
					label="Vacation Pay Open Balance"
					testId="Vacation-Pay-Open-Balance"
					labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				>
					<RHookFormNumericFormatTextField
						id={"vacationPayOpenBalance"}
						testId={`vacationPayOpenBalance`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper>
			<EnhancedDropDownRHFWithLabel
				selectName="includeInT4OrRl1"
				label="Include in T4/RL-1"
				labelPosition={LabelPosition.Top}
				// required
				testId={`Include-in-T4/RL-1`}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Dental Benefits"
				selectName="dentalBenefits"
				items={[
					{ label: "Not eligible", value: 100 },
					{ label: "Payee only", value: 200 },
					{ label: "Payee, Spouse, Children", value: 300 },
					{ label: "Payee, Spouse", value: 400 },
					{ label: "Payee, Children", value: 500 },
				]}
				showEmpty={true}
				testId="Dental-Benefits"
				labelPosition={LabelPosition.Top}
			/>
		</>
	);
};
